import { Stack, Typography } from "@mui/material";
import type { ReportField, SortField } from "../../../../../../../../../api/types/svTypes.ts";
import { getRunPublicApiReportUrl } from "../../../../../../report-lists/reports/utilities/editReportUrl.ts";
import { useBiCommonDataContext } from "../../../../../contexts/BiCommonDataContext.ts";
import { useRequestConfigViewer } from "../../../../viewer/tabular/hooks/useRequestConfigViewer.ts";
import CodeContainer from "./CodeContainer.tsx";
import CopyButton from "./CopyButton.tsx";
import { createCurlCommand, createJson, createRequestConfig } from "./helpers/codeHelper.tsx";

interface Props {
  fields: ReportField[];
  sorting: SortField[];
  isLoading: boolean;
  isQueryLoggingActive: boolean;
  sessionId: string;
}
const RequestCode = ({ fields, sorting, isLoading, isQueryLoggingActive, sessionId }: Props) => {
  const { reportId, conditions } = useBiCommonDataContext();

  const { requestConfig } = useRequestConfigViewer({
    fields,
    conditions,
    sorting,
    reportId,
    sessionId,
    isQueryLoggingActive,
  });
  const payload = createRequestConfig(requestConfig);
  const curlCommand = createCurlCommand(payload, getRunPublicApiReportUrl());

  return (
    <CodeContainer
      Header={
        <>
          <Typography variant="h6">Request</Typography>
          <Stack direction="row" spacing={1}>
            <CopyButton title="Copy Payload" code={createJson(payload)} />
            <CopyButton title="Copy All" code={curlCommand} />
          </Stack>
        </>
      }
      code={curlCommand}
      isLoading={isLoading}
    />
  );
};

export default RequestCode;
